<template>
  <div class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail':bg}">
    </div>
      <section
        class="size_detail zero_right margin_top_detail padding_bottom_detail has-background-white">
        <div class="columns is-marginless detail_content detail_img_info max-height">
          <img :src="url" class="imageDetail" alt="">
          <a @click="$parent.show = false"
            class="detail_icon_close_right topVert">
            <b-icon
              icon="window-close"
              type="is-white">
            </b-icon>
          </a>
        </div>
        <div class="columns is-marginless detail_content">
          <div class="half_width rightVert topVert leftVert is-6">
            <h3 class="has-text-link has-text-weight-bold bottomVert">
              Caractéristiques:</h3>
            <div class="columns is-multiline is-marginless color-icon">
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="barcode"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Code face
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.facCode}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Panneau
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.panCode}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Matériel
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.materiel}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Support
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      Non reseigné
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="lightbulb-on-outline"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Éclairé
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{eclaire}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="half_width rigthViolet rightVert topVert is-6">
            <h3 class="has-text-dark has-text-weight-bold bottomVert">Visibilité:</h3>
            <div class="columns is-multiline is-marginless color-icon">
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker-circle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Localisation
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.localisation ?
                        detailReseauxLcComplet.localisation :
                        'Non renseigné'}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="angle-obtuse"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Angle de vision
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.angleDeVision ?
                        detailReseauxLcComplet.angleDeVision :
                        'Non renseigné'}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="arrow-right"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      En venant de
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.enVenantDe ?
                        detailReseauxLcComplet.enVenantDe :
                        'Non renseigné'}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="arrow-left"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      En allant vers
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.enAllantVers ?
                        detailReseauxLcComplet.enAllantVers :
                        'Non renseigné'}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Adresse
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{adresse}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { formatEclaire, formatAdresse, urlPhoto } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxLcComplet',
  props: ['detailReseauxLcComplet', 'bg'],
  data() {
    return {
      select: true,
    };
  },
  computed: {
    eclaire() {
      return formatEclaire(this.detailReseauxLcComplet.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailReseauxLcComplet);
    },
    url() {
      return urlPhoto(this.detailReseauxLcComplet.urlPhoto);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxLc/detailReseauxLcComplet.vue